import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface OssVatRateOrderingParams {
    readonly countryId: number;
    readonly ordering: {
        id: number;
        order: number
    }[];
}

export type OssVatRateOrderingResponse = {
    value: number,
    version: string
}[];

export class OssVatRateOrderingCommand extends Command<OssVatRateOrderingParams, OssVatRateOrderingResponse> { }

export class OssVatRateOrderingCommandHandlerBase implements CommandHandler<OssVatRateOrderingCommand, OssVatRateOrderingParams, OssVatRateOrderingResponse> {
    private static Url = TaggedUrl.join('/sales/vatRates/country/:countryId/order', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: OssVatRateOrderingCommand): Promise<OssVatRateOrderingResponse> {
        const { data } = await this.http.put(
            fillPlaceholders(OssVatRateOrderingCommandHandlerBase.Url, { countryId: command.params?.countryId }),
            {
                order: command.params?.ordering
            }
        );
        return data;
    }
}
